import type { Tier } from "./types";

/**
 * Tier taxonomy (Checkpoint 0, E1): Tier 1 = 80+, Tier 2 = 65–79, Tier 3 = <65,
 * derived from scf_score. This is the single source of the mapping; both the
 * card TierBadge and the Tier 1 triage count go through it.
 */
export function tierForScore(score: number): Tier {
  if (score >= 80) return 1;
  if (score >= 65) return 2;
  return 3;
}

export function tierLabel(tier: Tier): string {
  return `Tier ${tier}`;
}
